module.exports = __webpack_public_path__ + "09c2f9d1620996e4a7770cf4b567e0c2.png";